import { render, staticRenderFns } from "./printHKSales.vue?vue&type=template&id=6fae884a&scoped=true&"
import script from "./printHKSales.vue?vue&type=script&lang=js&"
export * from "./printHKSales.vue?vue&type=script&lang=js&"
import style0 from "./printHKSales.vue?vue&type=style&index=0&id=6fae884a&lang=less&scoped=true&media=print&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fae884a",
  null
  
)

component.options.__file = "printHKSales.vue"
export default component.exports